// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as UseEnv$Showside from "../hook/UseEnv.bs.js";
import * as UseSize$Showside from "../hook/UseSize.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as BasicTypes$Showside from "../types/BasicTypes.bs.js";
import * as LCPContext$Showside from "../context/LCPContext.bs.js";
import * as LazyRender$Showside from "../utils/LazyRender.bs.js";
import * as CategoryCard$Showside from "./CategoryCard.bs.js";
import * as ListPageGrid$Showside from "./ListPageGrid.bs.js";
import * as Configuration$Showside from "../types/Configuration.bs.js";
import * as QuickViewCard$Showside from "./QuickViewCard.bs.js";
import * as ListPageSlider$Showside from "./ListPageSlider.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as PlaceholderCard$Showside from "./PlaceholderCard.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as UseFirstAndLastCard$Showside from "../hook/UseFirstAndLastCard.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as QuickViewOverlay_Lazy$Showside from "../pages/QuickViewOverlay_Lazy.bs.js";
import * as InfiniteScrollProximitySensor$Showside from "../utils/InfiniteScrollProximitySensor.bs.js";
function usePagination(shape, viewport, category) {
  var match = UseEnv$Showside.use(undefined);
  var match$1 = category.categoryType;
  var match$2;
  if (typeof match$1 === "number") {
    match$2 = [undefined, 0];
  } else {
    switch (match$1.TAG | 0) {
      case /* Standard */1:
        var match$3 = match$1._0;
        match$2 = [match$3.loadMoreChildren, match$3.totalChildren];
        break;
      case /* QuickView */2:
        var match$4 = match$1._0;
        match$2 = [match$4.loadMoreChildren, match$4.totalChildren];
        break;
      case /* ConfigEmbed */4:
        var match$5 = match$1._0;
        match$2 = [match$5.loadMoreChildren, match$5.totalChildren];
        break;
      default:
        match$2 = [undefined, 0];
    }
  }
  var match$6 = UseApi$Showside.usePaginateCategories(undefined, match.smartnavApiHost, Configuration$Showside.nodeLimit, match$2[0], undefined);
  var match$7 = match$6.swr;
  var error = match$7.error;
  var setNumPages = match$7.setSize;
  var numPages = match$7.size;
  var data = match$7.data;
  var totalPlaceholderCount = match$2[1] - Math.imul(Configuration$Showside.nodeLimit, numPages + 1 | 0) | 0;
  var renderedPlaceholderCount = Caml.int_min(totalPlaceholderCount > 0 ? totalPlaceholderCount : 0, Configuration$Showside.nodeLimit);
  var renderedPlaceholderCount$1 = error === undefined || renderedPlaceholderCount < 1 ? renderedPlaceholderCount : 1;
  var numLoadedPages = Belt_Option.mapWithDefault(data, 1, function (data) {
    return data.length;
  });
  var getPlaceholders = function (param) {
    return Belt_Array.makeBy(renderedPlaceholderCount$1, function (i) {
      if (i !== 0) {
        return React.createElement(PlaceholderCard$Showside.make, {
          showTitle: false,
          shape: shape,
          kind: /* Category */1,
          dataTestId: "placeholder-card-testid",
          contentBoxStylableClassName: "category-card__content-box",
          titleStylableClassName: "category-card__title",
          key: "placeholder-" + String(i) + ""
        });
      }
      var tmp = {
        numLoadedPages: numLoadedPages,
        numPages: numPages,
        setNumPages: setNumPages,
        viewport: viewport,
        renderChildren: function (el) {
          return React.createElement(PlaceholderCard$Showside.make, {
            showTitle: false,
            shape: shape,
            kind: /* Category */1,
            dataTestId: "proximity-card-testid",
            contentBoxStylableClassName: "category-card__content-box",
            titleStylableClassName: "category-card__title",
            children: el
          });
        },
        key: "proximity-sensor"
      };
      if (error !== undefined) {
        tmp.error = error;
      }
      return React.createElement(InfiniteScrollProximitySensor$Showside.make, tmp);
    });
  };
  var renderCards = function (renderFn) {
    return Belt_Array.concat(Belt_Array.mapWithIndex(Belt_Array.concatMany(Belt_Array.map(Belt_Option.getWithDefault(data, []), function (page) {
      return page.categories;
    })), renderFn), getPlaceholders(undefined));
  };
  return {
    renderCards: renderCards,
    data: data
  };
}
function CategoryContent(Props) {
  var category = Props.category;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var layout = Props.layout;
  var enableSmartCardOpt = Props.enableSmartCard;
  var enableFirstCardOpt = Props.enableFirstCard;
  var enableLastCardOpt = Props.enableLastCard;
  var shouldCenterSlidesOpt = Props.shouldCenterSlides;
  var enableScrollbarOpt = Props.enableScrollbar;
  var priorityOpt = Props.priority;
  var index = Props.index;
  var isPaddingEnabledOpt = Props.isPaddingEnabled;
  var verticalPaddingOpt = Props.verticalPadding;
  var subCategories = Props.subCategories;
  var forcedSize = Props.forcedSize;
  var forcedShape = Props.forcedShape;
  var forcedRounded = Props.forcedRounded;
  var forcedHideTitleOpt = Props.forcedHideTitle;
  var forcedHideDescriptionOpt = Props.forcedHideDescription;
  var forcedOpenLinkOpt = Props.forcedOpenLink;
  var className = Props.className;
  var onOverlayProductClick = Props.onOverlayProductClick;
  var onCategoryClick = Props.onCategoryClick;
  var onQuickViewClick = Props.onQuickViewClick;
  var onProductClick = Props.onProductClick;
  var enableSmartCard = enableSmartCardOpt !== undefined ? enableSmartCardOpt : false;
  var enableFirstCard = enableFirstCardOpt !== undefined ? enableFirstCardOpt : true;
  var enableLastCard = enableLastCardOpt !== undefined ? enableLastCardOpt : true;
  var shouldCenterSlides = shouldCenterSlidesOpt !== undefined ? shouldCenterSlidesOpt : false;
  var enableScrollbar = enableScrollbarOpt !== undefined ? enableScrollbarOpt : true;
  var priority = priorityOpt !== undefined ? priorityOpt : 0;
  var isPaddingEnabled = isPaddingEnabledOpt !== undefined ? isPaddingEnabledOpt : true;
  var verticalPadding = verticalPaddingOpt !== undefined ? verticalPaddingOpt : false;
  var forcedHideTitle = forcedHideTitleOpt !== undefined ? forcedHideTitleOpt : false;
  var forcedHideDescription = forcedHideDescriptionOpt !== undefined ? forcedHideDescriptionOpt : false;
  var forcedOpenLink = forcedOpenLinkOpt !== undefined ? forcedOpenLinkOpt : function (param) {
    return /* ForceNoCards */3;
  };
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, match.categories);
  var subCategories$1 = Belt_Option.getWithDefault(subCategories, Category$Showside.getChildren(category));
  var match$1 = ViewportContext$Showside.use(undefined);
  var match$2 = match$1.windowSize;
  var windowHeight = match$2.height;
  var isMobile = match$1.isMobile;
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var previewMode = match$3.previewMode;
  var route = match$3.route;
  EntrypointContext$Showside.use(undefined);
  var match$4 = LCPContext$Showside.use(undefined);
  var onMainImageRendered = match$4.onMainImageRendered;
  var contentRef = React.useRef(null);
  UseSize$Showside.useSize(contentRef);
  var onImageRendered = React.useCallback(function (param) {
    Curry._1(onMainImageRendered, undefined);
  }, []);
  var cardSize = Belt_Option.getWithDefault(forcedSize, Category$Showside.CategoryCard.getCardSize(/* Md */4, category.card));
  var cardShape = Belt_Option.getWithDefault(forcedShape, Category$Showside.CategoryCard.getCardShape(undefined, undefined, category.card));
  var match$5 = UseFirstAndLastCard$Showside.use(/* Category */0, activeCategory, layout, enableSmartCard, enableFirstCard, enableLastCard, Curry._1(forcedOpenLink, category), category);
  var lastCard = match$5[1];
  var firstCard = match$5[0];
  var onOverlayProductClick$1 = Belt_Option.getWithDefault(onOverlayProductClick, function (param, param$1, param$2, param$3) {});
  var onProductClickFromOverlayClick = React.useCallback(function (param) {
    return function (param, product, variant) {
      return Curry._2(onProductClick, product, variant);
    };
  }, [RouterProvider$Showside.toString(route)]);
  var onCategoryClick$1 = React.useMemo(function () {
    return onCategoryClick;
  }, [RouterProvider$Showside.toString(route)]);
  var onQuickViewClick$1 = React.useMemo(function () {
    return onQuickViewClick;
  }, [RouterProvider$Showside.toString(route)]);
  var rootMarginX = Math.imul(match$2.width, isMobile ? 3 : 2);
  var slidesPerView = Math.ceil(Category$Showside.CardSize.getSlidesPerView(cardSize)) | 0;
  var slidesPerView$1 = priority !== 1 ? priority !== 2 ? undefined : slidesPerView : slidesPerView << 1;
  var sliderRef = React.useRef(null);
  var match$6 = React.useState(function () {
    return false;
  });
  var setSliderInitialized = match$6[1];
  var handleSliderInit = React.useCallback(function (swiperController) {
    sliderRef.current = swiperController.el;
    Curry._1(setSliderInitialized, function (param) {
      return true;
    });
  }, [category]);
  var getViewport = function (layout) {
    var match = sliderRef.current;
    if (layout.TAG === /* SliderLayout */0 && !(match == null)) {
      return sliderRef;
    } else {
      return scrollableContainerRef;
    }
  };
  var isQuickViewStoriesEnabled = Category$Showside.isQuickViewStoriesEnabled(category);
  var isAnySiblingQuickView = Belt_Array.some(subCategories$1, function (subCat) {
    var match = subCat.categoryType;
    if (typeof match === "number") {
      return false;
    }
    if (match.TAG !== /* QuickView */2) {
      return false;
    }
    var match$1 = match._0;
    if (match$1.products.length !== 0) {
      return true;
    } else if (Belt_Array.keep(match$1.children, Category$Showside.isQuickView).length !== 0) {
      return Category$Showside.isQuickView(category);
    } else {
      return false;
    }
  });
  var isSocialNetworkPost = Belt_Option.isSome(category.socialNetworkSource);
  var renderCard = function (cardIndex, subCat) {
    var fallbackElement = React.createElement(PlaceholderCard$Showside.make, {
      title: subCat.title,
      showTitle: subCat.showTitle && !forcedHideTitle,
      shape: cardShape,
      kind: /* Category */1,
      contentBoxStylableClassName: "category-card__content-box",
      titleStylableClassName: "category-card__title",
      key: subCat.id
    });
    var match = subCat.categoryType;
    var categoryCard;
    var exit = 0;
    if (typeof match === "number") {
      exit = 1;
    } else {
      switch (match.TAG | 0) {
        case /* Standard */1:
          if (Belt_Option.isSome(match._0.imageHotspots)) {
            var tmp = {
              category: subCat,
              shape: cardShape,
              showTitle: !forcedHideTitle,
              showDescription: !forcedHideDescription,
              enableViewProductButton: false,
              onClick: function (param, category) {
                Curry._1(onCategoryClick$1, category);
              },
              onOverlayProductClick: onProductClickFromOverlayClick,
              onImageRendered: onImageRendered,
              key: subCat.id
            };
            if (forcedRounded !== undefined) {
              tmp.rounded = Caml_option.valFromOption(forcedRounded);
            }
            categoryCard = React.createElement(QuickViewCard$Showside.make, tmp);
          } else {
            exit = 1;
          }
          break;
        case /* QuickView */2:
          if (isAnySiblingQuickView || isQuickViewStoriesEnabled || isSocialNetworkPost) {
            Curry._1(QuickViewOverlay_Lazy$Showside.preload, undefined);
            var tmp$1 = {
              category: subCat,
              parentCategory: category,
              shape: cardShape,
              showTitle: !forcedHideTitle,
              showDescription: !forcedHideDescription,
              showTaggedProducts: !isMobile,
              onClick: onQuickViewClick$1,
              onOverlayProductClick: onOverlayProductClick$1,
              onImageRendered: onImageRendered,
              key: subCat.id
            };
            if (forcedRounded !== undefined) {
              tmp$1.rounded = Caml_option.valFromOption(forcedRounded);
            }
            categoryCard = React.createElement(QuickViewCard$Showside.make, tmp$1);
          } else {
            exit = 1;
          }
          break;
        default:
          exit = 1;
      }
    }
    if (exit === 1) {
      var tmp$2 = {
        category: subCat,
        shape: cardShape,
        showTitle: !forcedHideTitle,
        forcedOpenLink: Curry._1(forcedOpenLink, subCat) === /* ForceAllCards */0,
        showDescription: !forcedHideDescription,
        onClick: onCategoryClick$1,
        onImageRendered: onImageRendered,
        key: subCat.id
      };
      if (forcedRounded !== undefined) {
        tmp$2.rounded = Caml_option.valFromOption(forcedRounded);
      }
      categoryCard = React.createElement(CategoryCard$Showside.make, tmp$2);
    }
    var visibleByDefault = index < 3 && cardIndex < 3 || Caml_obj.equal(previewMode, /* PreviewHead */0);
    if (visibleByDefault) {
      return categoryCard;
    } else {
      return React.createElement(LazyRender$Showside.make, {
        trackRenderedElementsWithId: subCat.id,
        thresholds: [0.1],
        rootMargin: "" + String(windowHeight) + "px " + String(rootMarginX) + "px",
        viewport: getViewport(layout),
        children: categoryCard,
        fallbackElement: fallbackElement,
        key: subCat.id
      });
    }
  };
  var match$7 = usePagination(cardShape, getViewport(layout), category);
  var renderPaginatedCards = match$7.renderCards;
  var cards = React.useMemo(function () {
    var cards = Belt_Array.concat(Belt_Array.mapWithIndex(subCategories$1, renderCard), Curry._1(renderPaginatedCards, renderCard));
    if (slidesPerView$1 !== undefined) {
      return Belt_Array.slice(cards, 0, slidesPerView$1);
    } else {
      return cards;
    }
  }, [match.lastModifiedAt, Belt_Array.joinWith(subCategories$1, "|", function (cat) {
    return cat.id;
  }), cardShape, onCategoryClick$1, onOverlayProductClick$1, onImageRendered, onProductClickFromOverlayClick, slidesPerView$1, rootMarginX, windowHeight, match$6[0], BasicTypes$Showside.layoutToString(layout), match$7.data]);
  if (layout.TAG === /* SliderLayout */0) {
    if (cards.length === 0) {
      return null;
    }
    var match$8 = layout._0;
    var tmp = {
      id: category.id,
      rows: match$8.rows,
      children: cards,
      shouldCenter: shouldCenterSlides,
      slidesPerView: match$8.slidesPerView,
      gap: match$8.gap,
      effect: match$8.effect,
      nav: match$8.nav,
      transition: match$8.transition,
      transitionSpeed: match$8.transitionSpeed,
      autoplay: match$8.autoplay,
      autoplayDelay: match$8.autoplayDelay,
      loop: match$8.loop,
      duplicateSlidesForLoopingAutoplay: true,
      verticalPadding: verticalPadding,
      enableScrollbar: enableScrollbar,
      onInit: handleSliderInit
    };
    if (match$8.padding !== undefined) {
      tmp.padding = match$8.padding;
    }
    if (match$8.maxWidth !== undefined) {
      tmp.maxWidth = match$8.maxWidth;
    }
    if (firstCard !== undefined) {
      tmp.firstSlide = Caml_option.valFromOption(firstCard);
    }
    if (lastCard !== undefined) {
      tmp.lastSlide = Caml_option.valFromOption(lastCard);
    }
    if (className !== undefined) {
      tmp.className = Caml_option.valFromOption(className);
    }
    return React.createElement(ListPageSlider$Showside.make, tmp);
  }
  if (cards.length === 0) {
    return null;
  }
  var match$9 = layout._0;
  var tmp$1 = {
    columns: match$9.columns,
    children: cards,
    gap: match$9.gap,
    verticalPadding: verticalPadding
  };
  if (match$9.maxRows !== undefined) {
    tmp$1.maxRows = match$9.maxRows;
  }
  if (match$9.maxWidth !== undefined) {
    tmp$1.maxWidth = match$9.maxWidth;
  }
  var tmp$2 = isPaddingEnabled ? match$9.padding : 0;
  if (tmp$2 !== undefined) {
    tmp$1.paddingOverride = tmp$2;
  }
  if (firstCard !== undefined) {
    tmp$1.firstChild = Caml_option.valFromOption(firstCard);
  }
  if (lastCard !== undefined) {
    tmp$1.lastChild = Caml_option.valFromOption(lastCard);
  }
  if (className !== undefined) {
    tmp$1.className = Caml_option.valFromOption(className);
  }
  return React.createElement(ListPageGrid$Showside.make, tmp$1);
}
CategoryContent.displayName = "CategoryContent";
var make = React.memo(CategoryContent);
export { usePagination, make };
/* make Not a pure module */